import type { ButtonProps } from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import type { MouseEvent, PropsWithChildren } from "react";
import { useState } from "react";

export function AsyncLoadingIconButton({
  children,
  onClick,
  ...rest
}: PropsWithChildren<{
  onClick(e: MouseEvent): Promise<void>;
}> &
  Omit<ButtonProps, "onClick" | "loading">) {
  const [loading, setLoading] = useState(false);

  const handleClick = async (e: MouseEvent) => {
    setLoading(true);
    try {
      await onClick(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <IconButton loading={loading} onClick={handleClick} {...rest}>
      {children}
    </IconButton>
  );
}
